import './Header.css';
import Home from './home/Home';
import './App.css';
import License from './license/license';

function App() {
  return (
    <div className="App">
      <div className='Header'>
      
        <div className='HeaderItem'>
          <span>Home</span>
        </div>

        <div className='HeaderItem'>
          <span>XR & Game</span>
        </div>
        
        <div className='HeaderItem'>
          <span>Web</span>
        </div>

        <div className='HeaderItem'>
          <span>Paintings</span>
        </div>

      </div>
      <Home/>

      {navigator.language.startsWith('zh')?(
        <License/>
      ):null}
    </div>
  );
}

export default App;
